// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fe","advertDetailHeaderPrice__value":"c-m_ff","advertDetailHeaderPrice__label":"c-m_fg"};